module.exports = __webpack_public_path__ + "img/title.1a7d2d12.png";